<template>
  <div>
    <vs-sidebar :hidden-background="true" class="full-vs-sidebar email-view-sidebar items-no-padding" click-not-close
                parent="#email-app"
                position-right v-model="isSidebarActive">
      <div class="mail-sidebar-content px-0 sm:pb-6 h-full" v-if="currentMail">
        <!--MAIL TOPIC & ACTION-->
        <div
          class="flex flex-wrap items-center email-header justify-between md:px-8 px-6 sm:pb-2 sm: pt-6 d-theme-dark-bg">
          <div class="flex mb-4">
            <div class="flex items-center">
              <feather-icon :icon="$vs.rtl ? 'ArrowRightIcon' : 'ArrowLeftIcon'"
                            @click="$emit('closeSidebar')"
                            class="cursor-pointer mr-4"
                            svg-classes="w-6 h-6"></feather-icon>
              <h4 v-if="currentMail.topic">{{ currentMail.topic }}</h4>
              <h4 v-else>{{ $t('pm.no-subject') }}</h4>
            </div>
          </div>
          <div class="ml-10 mb-4 mt-1">
            <div class="email__actions--single flex items-baseline">
              <feather-icon :icon="$vs.rtl ? 'ChevronsRightIcon' : 'ChevronsLeftIcon'"
                            @click="$emit('previousMail')"
                            class="cursor-pointer ml-4 hidden sm:inline-flex"
                            svg-classes="h-6 w-6"/>
              <feather-icon :icon="$vs.rtl ? 'ChevronsLeftIcon' : 'ChevronsRightIcon'"
                            @click="$emit('nextMail')"
                            class="cursor-pointer ml-4 hidden sm:inline-flex"
                            svg-classes="h-6 w-6"/>
            </div>
          </div>
        </div>

        <VuePerfectScrollbar :key="$vs.rtl"
                             :settings="settings" class="scroll-area-mail-content md:px-8 md:pb-8 pt-4 px-6 pb-6">

          <div class="vx-row mb-4"
               v-if="currentMail.privateMessageReplies && currentMail.privateMessageReplies.length && !showThread">
            <div class="vx-col w-full">
              <span @click="showThread = true" class="text-primary font-medium ml-10 cursor-pointer">
                {{ currentMail.privateMessageReplies.length }} {{ $t('pm.earlier-messages') }}
              </span>
            </div>
          </div>
          <div v-if="isSidebarActive">

            <!-- ALL MESSAGES - THREAD -->
            <div v-if="showThread">
              <div  class="vx-row">
                <div class="vx-col w-full" v-once>
                  <private-message-card :classSection="classSection"
                                        :courseOutlineRegistration="courseOutlineRegistration"
                                        :mailContent="currentMail"
                                        class="mb-10"/>
                </div>
              </div>
              <div :key="threadMail.id" class="vx-row"
                   v-for="(threadMail, index) in currentMail.privateMessageReplies.slice()">
                <div class="vx-col w-full" v-if="(index+1) !== currentMail.privateMessageReplies.slice().length">
                  <private-message-card :classSection="classSection"
                                        :courseOutlineRegistration="courseOutlineRegistration"
                                        :mailContent="threadMail"
                                        class="mb-10"/>
                </div>
              </div>
            </div>

            <!-- LATEST MESSAGE -->
            <div class="vx-row">
              <div class="vx-col w-full">
                <private-message-card :classSection="classSection"
                                      :courseOutlineRegistration="courseOutlineRegistration"
                                      :mailContent="lastMessage"/>
              </div>
            </div>

            <!--CLICK REPLY-->
            <div class="vx-row" style="margin-top: 2.2rem">
              <div class="vx-col w-full">
                <vx-card>
                  <div class="vx-row">
                    <div class="vx-col w-full flex justify-between">
                      <span class="text-lg">{{ $t('pm.click-here-to') }}
                        <a class="text-primary font-semibold cursor-pointer" @click="onReplyClick">{{ $t('pm.reply') }}</a>
                      </span>
                    </div>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>


    <!-- compose email -->
    <ValidationObserver v-slot="{ invalid }">
      <vs-prompt
        :accept-text="$t('pm.send')"
        :active.sync="showReplyForm"
        :cancel-text="$t('general.cancel')"
        :is-valid="!invalid"
        :title="$t('pm.new-message')"
        @accept="onSaveClick"
        @cancel="onCancelClick"
        @close="onCancelClick"
        class="email-compose">

        <VuePerfectScrollbar :key="$vs.rtl" :settings="settings" class="scroll-area p-4">
          <form @submit.prevent>
            <ValidationProvider :name="$t('pm.message')" rules="required" v-slot="{ errors }">
            <quill-editor class="mt-2" :options="editorOption" v-model="mailMessage"/>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </form>
        </VuePerfectScrollbar>
      </vs-prompt>
    </ValidationObserver>
  </div>
</template>

<script>
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import {quillEditor} from 'vue-quill-editor'
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'
  import PrivateMessageCard from "./PrivateMessageCard";
  import store from '../../../../store';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";
  import PrivateMessageReply from '../../../../store/modules/private-message-reply/index';

  if (!store.state.PrivateMessageReply) store.state.registerModule(`PrivateMessage`, PrivateMessageReply);

  const {
    mapActions: mapPrivateMessageReplyActions,
  } = createNamespacedHelpers(`PrivateMessageReply`);
  const {
    mapFields: mapPrivateMessageReplyFields,
  } = createHelpers({
    getterType: `PrivateMessageReply/getField`,
    mutationType: `PrivateMessageReply/updateField`,
  });


  export default {
    props: [
      'openMailId',
      'isSidebarActive',
      'privateMessage',
      'hasPreviousMail',
      'hasNextMail',
      'currentUser',
    ],
    data() {
      return {
        showThread: false,
        settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.50,
        },
        showReplyForm: false,
        mailMessage: '',
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
              [{'header': 1}, {'header': 2}],
              [{'list': 'ordered'}, {'list': 'bullet'}],
              [{'font': []}],
            ],
          },
          placeholder: this.$t('pm.message'),
        },
      }
    },
    watch: {
      isSidebarActive(value) {
        if (!value) {
          this.$emit('closeSidebar')
          setTimeout(() => {
            this.showThread = false
          }, 500)
        }
      },
    },
    computed: {
      ...mapPrivateMessageReplyFields({
        privateMessageReplyProcessing: 'processing',
        privateMessageReplyError: 'error',
        privateMessageReplySuccess: 'success'
      }),
      currentMail() {
        return this.privateMessage
      },
      labelColor() {
        return (label) => {
          const tags = this.$store.state.email.mailTags
          return tags.find((tag) => {
            return tag.value === label
          }).color
        }
      },
      currentMailLabels: {
        get() {
          return this.currentMail.labels
        },
        set(value) {
          if (Array.isArray(value)) {
            const payload = {mailId: this.openMailId, labels: value}
            this.$store.dispatch('email/setLabels', payload)
          }
        }
      },
      classSection() {
        return this.privateMessage.classSection
      },
      courseOutlineRegistration() {
        return this.privateMessage.courseOutlineRegistration
      },
      lastMessage(){
        if(this.privateMessage &&
          this.privateMessage.privateMessageReplies &&
          this.privateMessage.privateMessageReplies.length > 0){
          return this.privateMessage.privateMessageReplies[this.privateMessage.privateMessageReplies.length - 1];
        }
        return this.privateMessage;
      }
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapPrivateMessageReplyActions({
        addPrivateMessageReply: 'addPrivateMessageReply',
      }),
      moveTo(to) {
        this.$emit('closeSidebar')
        this.$emit('moveTo', to)
      },
      onReplyClick(){
        this.mailMessage = '';
        this.showReplyForm = true;
      },
      onCancelClick(){
        this.showReplyForm = false;
      },
      async onSaveClick(){
        let toUser;
        if(this.currentUser.id !== this.privateMessage.fromUser.id){
          toUser = this.privateMessage.fromUser;
        }else{
          toUser = this.privateMessage.toUser;
        }
        const payload = {
          privateMessageId: this.privateMessage.id,
          toUserId: toUser.id,
          privateMessageReplyInput: {
            toUserCode: toUser.code,
            message: this.mailMessage,
            isFromTeacher: false,
            isFromStudent: true,
          },
        }
        let result = await this.addPrivateMessageReply(payload);
        if(result){
          result = JSON.parse(JSON.stringify(result));
          this.$emit('updateDateAfterReply', result);
        }
      },
    },
    components: {
      VuePerfectScrollbar,
      PrivateMessageCard,
      quillEditor,
    },
    /*updated() {
      if (!this.currentMail) return
      /!*if (this.currentMail.unread && this.isSidebarActive) this.$store.dispatch('email/setUnread', {
        emailIds: [this.openMailId],
        unread: false
      });*!/
    },*/
  }

</script>

